import { useChat } from "@/context/ChatContext";

export default function Footer() {
  const { setPrivacyOpen, waDefault } = useChat();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-brand-950 pt-14 pb-44 sm:pb-14 text-brand-100" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/favicon.svg" alt="Logotipo Isabela Guedes" className="h-10 w-10 rounded-xl" />
              <div className="leading-tight">
                <p className="font-display text-lg font-bold text-white">Isabela Guedes</p>
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300">
                  Consultora Porto Seguro
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-base leading-relaxed text-brand-200/80">
              Consórcio de imóveis e veículos com planejamento, clareza e atendimento humano —
              do primeiro contato à sua carta de crédito.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-300">Navegue</p>
            <ul className="mt-4 space-y-2.5 text-base">
              <li><a href="#como-funciona" className="transition-colors hover:text-white">Como funciona</a></li>
              <li><a href="#comparativo" className="transition-colors hover:text-white">Consórcio x financiamento</a></li>
              <li><a href="#imoveis" className="transition-colors hover:text-white">Consórcio de imóvel</a></li>
              <li><a href="#veiculos" className="transition-colors hover:text-white">Consórcio de veículo</a></li>
              <li><a href="#faq" className="transition-colors hover:text-white">Dúvidas frequentes</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-300">Contato e privacidade</p>
            <ul className="mt-4 space-y-2.5 text-base">
              <li>
                <a href={waDefault()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="transition-colors hover:text-white">
                  WhatsApp: (71) 98367-0243
                </a>
              </li>
              <li>
                <a href="mailto:isaguedes1319@gmail.com" data-testid="footer-email-link" className="transition-colors hover:text-white">
                  isaguedes1319@gmail.com
                </a>
              </li>
              <li>
                <button
                  data-testid="footer-privacy-button"
                  onClick={() => setPrivacyOpen(true)}
                  className="text-left transition-colors hover:text-white"
                >
                  Política de privacidade (LGPD)
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-delete-data-button"
                  onClick={() => setPrivacyOpen(true)}
                  className="text-left transition-colors hover:text-white"
                >
                  Pedir exclusão dos meus dados
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 space-y-3 border-t border-white/10 pt-8 text-[11px] leading-relaxed text-brand-300/70">
          <p>
            Aviso legal: este site é de uso pessoal da consultora e não é material oficial da Porto
            Seguro S.A., não a representando institucionalmente. Consórcio sujeito à análise e às
            regras do grupo de consórcio vigente. Taxa de administração e fundo de reserva aplicáveis.
            Não há garantia de contemplação nem de prazo de contemplação. Simulações e condições
            sujeitas à análise.
          </p>
          <p>© {year} Isabela Guedes — Consultora autorizada Porto Seguro. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
